import React from 'react';
import ReportsTableSummary from "../../Common/ReportsTableSummary";
import { reasonKeyToContent } from "../FeedbackReports.constants";
import { getReportColumnsForSeries } from "../FeedbackReports.utils";
import { getAppsWidth, headerConfigByFilter } from "../FeedbackReportsHead";
export default function FeedbacksSummary(props) {
  const {
    totalSeries,
    reportBy,
    source
  } = props;
  const reportColumns = getReportColumnsForSeries(totalSeries, reportBy, source);
  const allAppsWidth = getAppsWidth(reportBy);
  const summary = [{
    head: 'All apps',
    width: "".concat(allAppsWidth, "%")
  }];
  const headersConfig = headerConfigByFilter[reportBy] || headerConfigByFilter[source];
  headersConfig.map((reasonKey, index) => summary.push({
    head: reasonKeyToContent[reasonKey].name,
    content: reportColumns[index].content,
    width: "".concat((100 - allAppsWidth) / reportColumns.length, "%")
  }));
  summary.push({
    head: 'Total',
    content: reportColumns[reportColumns.length - 1].content,
    width: "".concat((100 - allAppsWidth) / reportColumns.length, "%")
  });
  return /*#__PURE__*/React.createElement(ReportsTableSummary, {
    summary: summary
  });
}